import React from 'react';
import { useTranslation } from 'react-i18next';

export function PositionControls({ 
  item, 
  totalItems, 
  positionInputs, 
  setPositionInputs, 
  onPositionUpdate, 
  isUpdating, 
  sortMode 
}) {
  const { t } = useTranslation();

  if (!sortMode) return null;

  const moveToTop = () => onPositionUpdate(item.id, 1);
  const moveUp = () => onPositionUpdate(item.id, Math.max(1, item.sort_order - 1));
  const moveDown = () => onPositionUpdate(item.id, item.sort_order + 1);
  const moveToBottom = () => onPositionUpdate(item.id, totalItems);

  return (
    <div className="mt-2 mb-2 p-2 md:p-3 bg-gray-50 dark:bg-zinc-800 rounded-lg border border-gray-200 dark:border-zinc-700 max-w-full overflow-visible">
      <div className="flex flex-col gap-2">
        <div className="flex items-center justify-between gap-2">
          <div className="text-xs md:text-sm font-medium text-gray-700 dark:text-gray-300 flex-shrink-0">
            Pos:
          </div>
          <input
            type="number"
            min="1"
            max={totalItems}
            value={positionInputs[item.id] || item.sort_order}
            onChange={(e) => setPositionInputs({...positionInputs, [item.id]: e.target.value})}
            onBlur={(e) => {
              if (e.target.value && e.target.value !== item.sort_order.toString()) {
                onPositionUpdate(item.id, e.target.value);
              }
            }}
            onKeyPress={(e) => {
              if (e.key === 'Enter' && e.target.value !== item.sort_order.toString()) {
                onPositionUpdate(item.id, e.target.value);
              }
            }}
            className="w-12 md:w-16 px-1 md:px-2 py-0.5 md:py-1 text-center border border-gray-300 dark:border-zinc-600 rounded bg-white dark:bg-zinc-800 text-gray-900 dark:text-white text-xs md:text-sm"
            title={t('position.input', 'Neue Position eingeben')}
            disabled={isUpdating}
          />
        </div>
        <div className="grid grid-cols-4 gap-0.5 md:gap-1 pb-1">
          <button
            onClick={moveToTop}
            disabled={isUpdating}
            className="p-0.5 md:p-1 hover:bg-gray-200 dark:hover:bg-zinc-700 rounded text-gray-600 dark:text-gray-400 text-xs disabled:opacity-50 disabled:cursor-not-allowed"
            title={t('position.move_to_top', 'Ganz nach oben')}
          >
            ⬆
          </button>
          <button
            onClick={moveUp}
            disabled={isUpdating}
            className="p-0.5 md:p-1 hover:bg-gray-200 dark:hover:bg-zinc-700 rounded text-gray-600 dark:text-gray-400 text-xs disabled:opacity-50 disabled:cursor-not-allowed"
            title={t('position.move_up', 'Nach oben')}
          >
            ↑
          </button>
          <button
            onClick={moveDown}
            disabled={isUpdating}
            className="p-0.5 md:p-1 hover:bg-gray-200 dark:hover:bg-zinc-700 rounded text-gray-600 dark:text-gray-400 text-xs disabled:opacity-50 disabled:cursor-not-allowed"
            title={t('position.move_down', 'Nach unten')}
          >
            ↓
          </button>
          <button
            onClick={moveToBottom}
            disabled={isUpdating}
            className="p-0.5 md:p-1 hover:bg-gray-200 dark:hover:bg-zinc-700 rounded text-gray-600 dark:text-gray-400 text-xs disabled:opacity-50 disabled:cursor-not-allowed"
            title={t('position.move_to_bottom', 'Ganz nach unten')}
          >
            ⬇
          </button>
        </div>
      </div>
    </div>
  );
}